import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';
import { Typography } from 'ui-v2/components/Typography';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
import { LayoutPropType } from '../../../types/layout';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import s from './BrowseCategoryListing.module.scss';
import AnimatedImage from 'core-lib/components/AnimatedImage';

export const BrowseCategoryListing = ({ data }: LayoutPropType) => {
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });

  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.layoutType;

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.sectionName);
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);
  return (
    !!data && (
      <div
        className={s.root}
        style={{
          background: `url(${data?.backgroundImage})`,
          // objectFit: 'cover',
        }}
        ref={rootRef}
        onClick={(e) =>
          handleItemClickWithDelegation(
            e,
            CARDID,
            data?.entityType,
            data?.data,
            data?.sectionName || 'TOP_CATEGORIES'
          )
        }
      >
        {!!data?.title && (
          <Typography
            label={data?.title}
            variant="label_3_medium"
            className={s.title}
          />
        )}
        <div className={s.container}>
          {data?.data?.map((item, index) => (
            <div
              key={item?.productId}
              className={s.item}
              id={CARDID}
              data-index={index}
            >
              <div className={s.image}>
                <AnimatedImage src={item?.coverImage} alt="coverImage" />
              </div>
              <Typography
                label={item?.title}
                variant="label_3_medium"
                color="primary"
              />
            </div>
          ))}
        </div>
      </div>
    )
  );
};
